<div>
    <div class="hero bg-cover" style="background-image: url(hero_img.jpg)">
        <div class="hero-overlay bg-opacity-30"></div>
        <div class="hero-content text-center text-neutral-content">
            <div class="max-w-md mt-24 text-white">
                <h3 class="text-5xl weight">Serenity</h3>
                <h1 class="text-9xl -mt-4">Now</h1>
                <p class="mb-5 text-xl">Located at Ajodha Hill Top.</p>
            </div>
        </div>
    </div>
</div>
